/**
 * workStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import * as helpers from '../../utils/helpers';

const FLY_LOG = 'FLY_LOG';
const LIVEP = 'LIVEP';

export default {
    namespaced: true,

    state: {
        // work
        liveParams: {},
    },

    mutations: {
        [LIVEP](state, params) {
            const params1 = localStorage.getItem('params');
            const result = JSON.parse(params1);
            state.liveParams = result || {};
        },

    },

    actions: {

        storageLiveParams({ commit }, params) {
            localStorage.setItem('params', JSON.stringify(params));

            commit(LIVEP, params);
        },
        // end of actions
    },
};
